export var DIGI_FORM_ASSETS_PATH = process.env.REACT_APP_DIGI_FORM_ASSETS_PATH || 'https://kuser-service.s3-eu-west-1.amazonaws.com/v2/prod/2.4.0/data';
export var Schema;
(function (Schema) {
    Schema["DATA_SCHEMA_FILE"] = "formDataSchema";
    Schema["UI_SCHEMA_FILE"] = "formUISchema";
})(Schema || (Schema = {}));
export var ROOT_CONTAINER_ID = process.env.REACT_APP_DIGI_FORM_ROOT_CONTAINER_ID || 'digi-react-form';
export var DIGI_FORM_STEPPER_ATTR = process.env.REACT_APP_DIGI_FORM_STEPPER_ATTR || 'data-form-stepper';
export var DIGI_FORM_SERVICE_ATTR = process.env.REACT_APP_DIGI_FORM_SERVICE_ATTR || 'data-form-service';
export var DIGI_FORM_DELETE_URL_ATTR = process.env.REACT_APP_DIGI_FORM_DELETE_URL_ATTR || 'data-delete-account-url';
export var DIGI_FORM_DELETE_INIT_ATTR = process.env.REACT_APP_DIGI_FORM_DELETE_HEADERS_ATTR || 'data-delete-account-headers';
export var DIGI_FORM_DELETE_REDIRECT_URL_ATTR = process.env.REACT_APP_DIGI_FORM_DELETE_REDIRECT_URL_ATTR || 'data-delete-account-redirect-url';
export var CONSTRAINT_FIELD_ENDPOINT = process.env.REACT_APP_CONSTRAINT_FIELD_ENDPOINT || '';
export var USER_PROFILE_VERSION = process.env.REACT_APP_USER_PROFILE_VERSION || 'v2';
//# sourceMappingURL=config.js.map